import { useMutation, useQuery } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import useSubscribers from "../../common/hooks/pages/useSubscribers";
import Subscribers from "../components/Subscribers";
import ApiValidate from "../../common/components/ApiValidate";
import { useCallback, useState } from "react";
import { getDefaultAction } from "../../common/helpers/common";
import { useApp } from "../../common/contexts/AppContext";

function SubscriberContainer() {
  const [subscribers, setSubscribers] = useState();
  const [action, setAction] = useState(getDefaultAction());

  const onClose = useCallback(() => {
    setAction(getDefaultAction());
  }, []);

  const { toast } = usePopup();

  const { getSubscribers, deleteSubscriber } = useSubscribers();

  const { isOwner } = useApp();

  const { isError, isLoading, refetch } = useQuery({
    retry: false,
    queryKey: "getSubscribers",
    queryFn: getSubscribers,
    onSuccess: (res) => {
      setSubscribers(res?.data?.subscribersForPage || {});
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting pages!";
      toast(message, "error");
    },
  });

  const { mutate: deleteSubscriberMutate, isLoading: isDeleting } = useMutation(
    {
      mutationFn: deleteSubscriber,
      onSuccess: (res) => {
        const { message } = res?.data || {};

        refetch();

        onClose();

        toast(message, "success");
      },
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          "Something went wrong while deleting subscriber!";

        toast(message, "error");
      },
    }
  );
  return (
    <ApiValidate isLoading={isLoading} isError={isError}>
      <Subscribers
        action={action}
        setAction={setAction}
        onClose={onClose}
        subscribers={subscribers}
        refetch={refetch}
        isOwner={isOwner}
        onDelete={(subscriberId) => deleteSubscriberMutate(subscriberId)}
        isDeleting={isDeleting}
      />
    </ApiValidate>
  );
}

export default SubscriberContainer;
